<template>
  <div>
    <ShareDetailToolbar/>
    <WorkToolDetailHeader/>
    <WorkToolDetailProcedure/>
    <DetailChange/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WorkToolDetailHeader from "@/work/tool/components/WorkToolDetailHeader";
import WorkToolDetailProcedure from "@/work/tool/components/WorkToolDetailProcedure";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import DetailChange from "@/support/detail/components/DetailChange";
import ShareDetailToolbar from "@/support/share/components/ShareDetailToolbar";
import apptheme from "@/frame/theme/mixins/apptheme.js";

export default {
  components: {
    WorkToolDetailHeader,
    WorkToolDetailProcedure,
    DetailChange,
    ShareDetailToolbar
  },
  // eslint-disable-next-line
  mixins: [apptheme, storeFunctions],
  data() {
    return {
      valid: true,
      value: "",
      tab: ""
    };
  },
  beforeDestroy() {
    this.$store.dispatch("changeDocumentRevMod", null);
    this.resetStoreDetail();
  },
  // eslint-disable-next-line
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getDetail", "getDataSavePendingIndication"]),
    dataSavePendingColor() {
      // eslint-disable-next-line
      if (this.getDataSavePendingIndication === true) {
        return "wplorange0";
      } else {
        return this.ui.bkgdColor;
      }
    }
  }
};
</script>
